import { useClient } from "../../../../hooks";
import { useQuery } from "react-query";

export const useParentalConsentFormQuery = (url) => {
  const client = useClient();

  return useQuery(
    [url],
    () => {
      return client.get(url).get("data");
    },
    {
      useErrorBoundary: false,
    }
  );
};
